// src/components/StatusColumn.js

import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import WorkOrderCard from './WorkOrderCard';

const StatusColumn = ({ title, workOrders, allStatuses, onStatusChange, onMarkAsDelivered }) => {
  return (
    <Paper 
      elevation={2} 
      sx={{ 
        p: 2, 
        backgroundColor: 'grey.100', 
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
        {title.toUpperCase()} ({workOrders.length})
      </Typography>
      <Box sx={{
        overflowY: 'auto',
        flexGrow: 1,
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-thumb': { backgroundColor: 'grey.400', borderRadius: '4px' }
      }}>
        {workOrders.map(order => (
          <WorkOrderCard 
            key={order.id} 
            workOrder={order} 
            statuses={allStatuses}
            onStatusChange={onStatusChange}
            onMarkAsDelivered={onMarkAsDelivered} // Eksik olan prop'u buraya ekledik
          />
        ))}
      </Box>
    </Paper>
  );
};

export default StatusColumn;